import React from "react";
import './Techstack.css';

import androidstudio from '../../assets/techIcons/androidstudio-original.svg';
import apple from '../../assets/techIcons/apple-original.svg';
import c from '../../assets/techIcons/c-original.svg';
import css3 from '../../assets/techIcons/css3-original.svg';
import figma from '../../assets/techIcons/figma-original.svg';
import firebase from '../../assets/techIcons/firebase-original.svg';
import git from '../../assets/techIcons/git-original.svg';
import html5 from '../../assets/techIcons/html5-original.svg';
import java from '../../assets/techIcons/java-original.svg';
import javascript from '../../assets/techIcons/javascript-original.svg';
import kotlin from '../../assets/techIcons/kotlin-original.svg';
import mongodb from '../../assets/techIcons/mongodb-original.svg';
import nodejs from '../../assets/techIcons/nodejs-original.svg';
import photoshop from '../../assets/techIcons/photoshop-original.svg';
import postman from '../../assets/techIcons/postman-original.svg';
import react from '../../assets/techIcons/react-original.svg';
import sqlite from '../../assets/techIcons/sqlite-original.svg';
import swift from '../../assets/techIcons/swift-original.svg';
import xcode from '../../assets/techIcons/xcode-original.svg';
import xd from '../../assets/techIcons/xd-original.svg';

const techStackData = [
    { name: "Android Studio", icon: androidstudio },
    { name: "Apple", icon: apple },
    { name: "C", icon: c },
    { name: "CSS3", icon: css3 },
    { name: "Figma", icon: figma },
    { name: "Firebase", icon: firebase },
    { name: "Git", icon: git },
    { name: "HTML5", icon: html5 },
    { name: "Java", icon: java },
    { name: "JavaScript", icon: javascript },
    { name: "Kotlin", icon: kotlin },
    { name: "MongoDB", icon: mongodb },
    { name: "Node.js", icon: nodejs },
    { name: "Photoshop", icon: photoshop },
    { name: "Postman", icon: postman },
    { name: "React", icon: react },
    { name: "SQLite", icon: sqlite },
    { name: "Swift", icon: swift },
    { name: "Xcode", icon: xcode },
    { name: "Adobe XD", icon: xd }
];

const Techstack = () => {
    return (
        <div id="tech" className="tech-stack-container">
            <div className="heading">
                <h2 className="front">Technologies;</h2> <h2 className="back">  I work on !</h2>
            </div>
            <div className="tech-icons">
                {techStackData.map((techItem, index) => (
                    <div className="tech-icon" key={index}>
                        <img src={techItem.icon} alt={techItem.name} />
                        <p>{techItem.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Techstack;
